import { render, staticRenderFns } from "./OrganizationChallenges.vue?vue&type=template&id=656ec229"
import script from "./OrganizationChallenges.vue?vue&type=script&lang=js"
export * from "./OrganizationChallenges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports